module.exports = __webpack_public_path__ + "static/ff-saleslanding-image-body-needyou-karl-anderson-KH-WE85l3kc-unsplash.29bd9015.jpg";